import { useQuery } from "@tanstack/vue-query";
import AgentService from "@/services/ai/agent";
import type { AgentLinkedInStatus } from "@/dtos/Agent.dto";

export const AGENT_LINKEDIN_STATUS_KEY = ["agent", "linkedin-status"] as const;

/**
 * Whether the rep's own LinkedIn account is connected. Refetched when the tab regains
 * focus, so the prompt clears once they come back from connecting it.
 */
export function useAgentLinkedInStatus() {
  return useQuery({
    queryKey: AGENT_LINKEDIN_STATUS_KEY,
    queryFn: async (): Promise<AgentLinkedInStatus> => {
      const result = await AgentService.getLinkedInStatus();
      if (!result.data.status) throw new Error(result.data.msg);
      return result.data.data.status as AgentLinkedInStatus;
    },
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
  });
}
